/*SYSTEM IMPORTS*/
    import React from 'react'

    import c from 'classnames'

    import { IsIsset } from 'helpers/ValueTests'
    import AppCore from 'cores/AppCore'
import { animate } from "helpers/Animations"

const clearSlashes = path => {
    if( IsIsset( path ) )
    {
        return path.toString().trim().replace( /\/$/g, '' ).replace( /^\//g, '' )
    }

    return path
}

const TransitTo = ( to, event = false ) => {
    if( IsIsset( to ) )
    {
        if( to.indexOf( '#' ) === 0 )
        {
            const { $ } = window

            if( event ) event.preventDefault()

            let element = document.querySelector( to )

            let header = document.querySelector("header.header")

            let headerOffset = 74

            if (header) {
                headerOffset = header.getBoundingClientRect().height
            }

            if( element )
            {
                /*element.scrollIntoView({ behavior: "smooth" })*/

                const start = window.pageYOffset

                const range = element.getBoundingClientRect().top - headerOffset

                animate({
                    draw: (progress) => {
                        window.scrollTo(0,  start + range * progress)
                    },
                })

            } else {
                AppCore.historyPush( `/${to}` )

                setTimeout(() => {
                    element = document.querySelector( to )

                    if( element )
                    {
                        /*element.scrollIntoView({ behavior: "smooth" })*/

                        const start = window.pageYOffset

                        const range = element.getBoundingClientRect().top - headerOffset

                        animate({
                            draw: (progress) => {
                                window.scrollTo(0,  start + range * progress)
                            },
                        })
                    }
                }, 500)

                // console.error( `Element not found: ${forElement}` )
            }
        } else {
            if( to.indexOf( 'http' ) === -1 && to.indexOf( 'tel:' ) !== 0 && to.indexOf( 'mailto:' ) !== 0 )
            {
                if( event ) event.preventDefault()

                AppCore.historyPush( to )
            } else {
                if( event === false )
                {
                    window.open( to )
                }
            }
        }
    }
}

const Link = ( props => {
    const to = props.to || props.href

    return (
        <a
            style={ props.style }
            href={ to }
            target={ props.target == undefined ? ( IsIsset( to ) && to.indexOf( 'http' ) > -1 ? '_blank' : '_self' ) : props.target }
            className={c( props.className, { active: clearSlashes( `${window.location.pathname}${window.location.hash}` ) == clearSlashes( to ) })}
            onClick={ e => {
                if( props.onClick )
                {
                    props.onClick( e )
                }

                if( IsIsset( to ) && props.target != '_blank' )
                {
                    TransitTo( to, e )
                }
            }}
        >
            { props.children }
        </a>
    )
})

export default Link

export { TransitTo, Link }